import React, { useState } from "react";
import "./App.css";
import Dropzone from "./components/Dropzone";
import Verifier from "./components/Verifier";
function App() {
  const [document, setDocument] = useState<any | null>(null);
  const handleFileUpload = (fileData: any) => {
    setDocument(fileData);
  };

  return (
    <div className="flex flex-col flex-grow min-h-screen overflow-x-hidden">
      <div>
        {document ? (
          <Verifier document={document} />
        ) : (
          <Dropzone onFileUpload={handleFileUpload} />
        )}
      </div>
    </div>
  );
}

export default App;
